var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg133(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2394 0C19.076 0.000114169 19.754 0.67801 19.754 1.51465V7.72168C19.7539 8.51823 19.1082 9.16406 18.3116 9.16406C17.5151 9.16401 16.8694 8.5182 16.8693 7.72168V4.7793L11.8507 9.77637C11.1501 10.4737 10.0204 10.4829 9.30773 9.79785L7.37219 7.9375C7.13339 7.70796 6.75463 7.71284 6.5216 7.94824L2.45422 12.0557C1.8892 12.6265 0.966353 12.6226 0.406366 12.0469C-0.141452 11.4836 -0.134552 10.5849 0.421991 10.0303L5.87414 4.59863C6.46451 4.01048 7.4193 4.00971 8.01086 4.59668L10.59 7.15527L14.9171 2.77148H11.9757C11.2104 2.77134 10.59 2.15104 10.59 1.38574C10.59 0.620392 11.2104 0.000143038 11.9757 0H18.2394Z",
    fill: "#F7941D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg133);
export default __webpack_public_path__ + "static/media/svg133.a8277e1377f2e5acf43b2c0c5e0dcf28.svg";
export { ForwardRef as ReactComponent };